import React, { useState, useEffect } from 'react';
import './HistoryModal.css'; // Reuse styles from HistoryModal
import { FaTimes } from 'react-icons/fa';

interface ContextModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (newContext: string) => Promise<void>;
  initialContext: string | null;
  isSaving: boolean;
}

const ContextModal: React.FC<ContextModalProps> = ({ isOpen, onClose, onSave, initialContext, isSaving }) => {
  const [context, setContext] = useState(initialContext || '');

  useEffect(() => {
    setContext(initialContext || '');
  }, [initialContext]);

  if (!isOpen) {
    return null;
  }

  const handleSave = () => {
    onSave(context);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <header className="modal-header">
          <h2>Additional Context</h2>
          <button className="modal-close-button" onClick={onClose}>
            <FaTimes />
          </button>
        </header>
        <div className="context-editor-container">
          <textarea
            className="context-textarea"
            value={context}
            onChange={(e) => setContext(e.target.value)}
            placeholder="Add any specific context to consider for this analysis..."
            rows={10}
          />
          <div className="modal-actions">
            <button className="save-button" onClick={handleSave} disabled={isSaving}>
              {isSaving ? 'Saving...' : 'Save and Re-analyze'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContextModal; 